const localStorageNamespace = 'whoop.';

const setItem = (name: string, content: string) => {
  window.localStorage.setItem(`${localStorageNamespace}.${name}`, content);
};

const getItem = (name: string) =>
  window.localStorage.getItem(`${localStorageNamespace}.${name}`);

const removeItem = (name: string) => {
  window.localStorage.removeItem(`${localStorageNamespace}.${name}`);
};

export { setItem, getItem, removeItem };
